type Props = {
  product: Queries.ProductPageFragmentFragment;
  selectedVariant: Queries.VariantDetailsFragmentFragment | undefined | null;
  pathname: string;
};

const YotpoReviewsWidget = ({ product, selectedVariant, pathname }: Props) => {
  return (
    <div
      sx={{
        // eslint-disable-next-line max-len
        '.yotpo-headline, .yotpo-reviews-icon-text, .yotpo-star-distribution-index, .yotpo-bottom-line-score, .yotpo-review-title, .yotpo-read-more-text, .yotpo-reviewer-name, .yotpo-reviewer-verified-buyer-text, .yotpo-date-format, .yotpo-review-votes-text, .yotpo-review-votes-number, .yotpo-bottom-line-basic-text':
          {
            fontFamily: 'HCo Gotham, Gotham B, system-ui, sans-serif !important',
            fontWeight: '400 !important',
          },
        '.yotpo-headline': {
          fontWeight: '500 !important',
        },
        '.yotpo-header-container': {
          display: 'grid',
        },
        '.yotpo-reviewer-image': {
          display: 'none',
        },
        '.yotpo-reviews-pagination-container': {
          marginBottom: 0,
        },
        '.yotpo-display-s .yotpo-head': {
          marginTop: 0,
        },
        '.yotpo-review-title': {
          display: 'none',
        },
      }}
      className="yotpo-widget-instance"
      data-yotpo-instance-id="778709"
      data-yotpo-product-id={product.slug}
      data-yotpo-name={product.longName}
      data-yotpo-url={`https://www.omorpho.com${pathname}`}
      data-yotpo-image-url={'https:' + selectedVariant?.mainImage?.file?.url}
      data-yotpo-price={selectedVariant?.price}
      data-yotpo-currency="USD"
      data-yotpo-description={product?.shortDescription}
    />
  );
};

export default YotpoReviewsWidget;
